import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      // Top-right so toasts don't cover bottom action bars (drawer footers,
      // board CTAs). Callers can still override via props.
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            "!bg-background !text-foreground !border-border !text-xs !font-medium !shadow-md",
          actionButton: "!bg-primary !text-primary-foreground !text-xs",
          cancelButton: "!bg-muted !text-muted-foreground !text-xs",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
